import React, { useEffect, useState } from 'react';
import axios from 'axios';

import { CmmContainer, CmmSubTitle, SalesTable, SalesTableBody, SalesTableCell, SalesTableRow } from 'components/Dashboard';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Grid';
import { CombinePairsChart } from 'components/Chart';
import { DataGrid } from '@mui/x-data-grid';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import moment from 'moment';
import { useRecoilValue } from 'recoil';
import { authAtom } from '../../../_state';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import DatePicker from '../../../components/Date/DatePicker';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { cmmUtils } from '../../../utils/cmmUtils';

const columns = [
  {
    field: 'id',
    headerName: '월',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    valueGetter: (params) => `${Number(params?.value.split('-')[1])}월`
  },
  {
    field: 'workDays',
    headerName: '근무 일',
    width: 90,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => params?.value?.toLocaleString()
  },
  {
    field: 'tMan',
    headerName: '근무 인원',
    width: 120,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const value = params?.value;
      if (typeof value === 'number') {
        return Math.floor(value).toLocaleString();
      }
      return value;
    }
  },
  {
    field: 'login1',
    headerName: '접속률(%)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const login = params?.row?.login;
      const tMan = params?.row?.tMan;

      if (typeof login === 'number' && typeof tMan === 'number' && tMan !== 0) {
        return ((login / tMan) * 100).toFixed(1) + '%';
      }
      return '-';
    }
  },
  {
    field: 'open1',
    headerName: 'DIDAS열람(%)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const open = params?.row?.open;
      const tMan = params?.row?.tMan;

      if (typeof open === 'number' && typeof tMan === 'number' && tMan !== 0) {
        return ((open / tMan) * 100).toFixed(1) + '%';
      }
      return '-';
    }
  },
  {
    field: 'upload1',
    headerName: '파일 업로드(%)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const upload = params?.row?.upload;
      const tMan = params?.row?.tMan;

      if (typeof upload === 'number' && typeof tMan === 'number' && tMan !== 0) {
        return ((upload / tMan) * 100).toFixed(1) + '%';
      }
      return '-';
    }
  },
  {
    field: 'login',
    headerName: '접속자(명)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => params?.value?.toLocaleString()
  },
  {
    field: 'tMan1',
    headerName: '일 평균 근무 인원',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const tMan = params?.row?.tMan;
      const workDays = params?.row?.workDays;

      if (typeof tMan === 'number' && typeof workDays === 'number' && workDays !== 0) {
        return Math.round(tMan / workDays).toLocaleString();
      }
      return '-';
    }
  },
  {
    field: 'login2',
    headerName: '접속자(일 평균)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const login = params?.row?.login;
      const workDays = params?.row?.workDays;

      if (typeof login === 'number' && typeof workDays === 'number' && workDays !== 0) {
        return (login / workDays).toFixed(1).toLocaleString();
      }
      return '-';
    }
  },
  {
    field: 'logout',
    headerName: '로그아웃',
    width: 100,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => params?.value?.toLocaleString()
  },
  {
    field: 'open',
    headerName: 'DIDAS열람',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => params?.value?.toLocaleString()
  },
  {
    field: 'open2',
    headerName: 'DIDAS열람(일 평균)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const open = params?.row?.open;
      const workDays = params?.row?.workDays;

      if (typeof open === 'number' && typeof workDays === 'number' && workDays !== 0) {
        return (open / workDays).toFixed(1).toLocaleString();
      }
      return '-';
    }
  },
  {
    field: 'upload',
    headerName: '파일 업로드',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => params?.value?.toLocaleString()
  },
  {
    field: 'upload2',
    headerName: '파일 업로드(일 평균)',
    width: 150,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (params) => {
      const upload = params?.row?.upload;
      const workDays = params?.row?.workDays;

      if (typeof upload === 'number' && typeof workDays === 'number' && workDays !== 0) {
        return (upload / workDays).toFixed(1).toLocaleString();
      }
      return '-';
    }
  }
];

export default function AnalysisSales() {
  const [monthChartParams, setMonthChartParams] = useState({});
  const [monthRows, setMonthRows] = useState([]);
  const [datas, setDatas] = useState({});
  const [srchData, setSrchData] = useState({
    cond: 'month'
  });
  const [years, setYears] = useState([]);
  const [year, setYear] = useState(moment().format('YYYY'));
  const [months, setMonths] = useState([]);
  const [month, setMonth] = useState(moment().format('MM'));

  const [partList, setPartList] = useState([]);
  const [selectedPart, setSelectedPart] = useState('all');

  const [currentYearMonth, setCurrentYearMonth] = useState();
  const [open, setOpen] = useState(false);

  const auth = useRecoilValue(authAtom);

  const onOpen = () => setOpen(true);
  const onClose = () => setOpen(false);

  const handleRowClick = (params) => {
    setDatas(params.row);
    setCurrentYearMonth(params.row.id);
    onOpen();
  };

  const getYears = async () => {
    const response = await axios.get('/api/dashboard/anls-agent/years');
    if (response) {
      setYears(response.data);
      setSrchData({ ...srchData, year: response.data[0] });
    }
  };

  const getMonths = async () => {
    let tempMonths = [];
    for (let i = 1; i <= 12; i++) {
      tempMonths = [...tempMonths, i];
    }
    setMonths(tempMonths);
  };

  const getMonthChart = (params) => {
    const categories = params.map((t) => `${Number(t?.id.split('-')[1])}월`);
    const series = [
      {
        name: '접속자',
        type: 'line',
        data: params.map((param) => {
          const login = param?.login;
          const tMan = param?.tMan;

          if (typeof login === 'number' && typeof tMan === 'number' && tMan !== 0) {
            return ((login / tMan) * 100).toFixed(1);
          }
          return null;
        }),
        yaxis: 0
      },
      {
        name: 'DIDAS 열람',
        type: 'line',
        data: params.map((param) => {
          const open = param?.open;
          const tMan = param?.tMan;

          if (typeof open === 'number' && typeof tMan === 'number' && tMan !== 0) {
            return ((open / tMan) * 100).toFixed(1);
          }
          return null;
        }),
        yaxis: 0
      },
      {
        name: '파일 업로드',
        type: 'line',
        data: params.map((param) => {
          const upload = param?.upload;
          const tMan = param?.tMan;

          if (typeof upload === 'number' && typeof tMan === 'number' && tMan !== 0) {
            return ((upload / tMan) * 100).toFixed(1);
          }
          return null;
        }),
        yaxis: 0
      }
    ];
    const yaxis = [
      {
        showAlways: true,
        title: {
          text: '접속자수/열람/업로드'
        },

        min: 0,
        max: 100
      }
    ];
    return { categories, series, yaxis };
  };

  const getChartMonth = async () => {
    const { cond } = srchData;
    const { startYmd, endYmd } = datas;

    await axios
      .get('/api/dashboard/anls-agent/chart', { params: { cond, year, startYmd, endYmd, sectorCd: selectedPart, subPartList: partList.filter((part) => part.sectorCd === selectedPart).map((part) => part.deptNm) } })
      .then((response) => {
        const params = response.data;
        const result = getMonthChart(params);
        setMonthChartParams({ ...result });
        console.log('🔥csl🔥AnalysisAgent/ :309 - result = ', result);
        setMonthRows(params);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(async () => {
    getYears();
    getMonths();

    await axios
      .get('https://didas.dohwa.co.kr/agent/app/dept/info', {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': '*',
          'Access-Control-Allow-Credentials': 'true'
        }
      })
      .then((response) => {
        setPartList(response.data.deptList.filter((part) => (part.lv === '1' || part.lv === '2' || part.lv === '3' || part.lv === '4' || part.lv === '5') && part.useYn === 'Y' && part.parentDeptCd !== '00000000000000018502'));
      })
      .catch((error) => {
        console.log(error);
      });
  }, [auth]);

  useEffect(async () => {
    if (auth) {
      getChartMonth();
    }
  }, [year, month, auth, selectedPart]);

  useEffect(() => {
    if (datas?.startYmd && datas?.endYmd) getChartMonth();
  }, [datas, getChartMonth]);

  return (
    <Stack spacing={2} sx={{ maxWidth: 800 }}>
      <CmmContainer sx={{ width: '100%', display: 'block' }}>
        <Stack direction="row" spacing={2}>
          <Select
            labelId="gbn-label"
            name="year"
            value={year || ''}
            label="검색기준"
            onChange={(e) => {
              setYear(e.target.value);
            }}
          >
            {years.map((year, idx) => (
              <MenuItem key={idx} value={year}>
                {year}년
              </MenuItem>
            ))}
          </Select>

          <Select
            labelId="gbn-label"
            name="month"
            value={Number(month) || ''}
            label="검색기준"
            onChange={(e) => {
              setMonth(e.target.value);
            }}
          >
            {months.map((month, idx) => (
              <MenuItem key={idx} value={month}>
                {month}월
              </MenuItem>
            ))}
          </Select>
          <FormControl>
            <InputLabel variant="standard">부문</InputLabel>
            <Select labelId="gbn-label" name="part" value={selectedPart} label="검색기준" onChange={(e) => setSelectedPart(e.target.value)}>
              <MenuItem value={'all'}>전체</MenuItem>
              {partList
                .filter((part) => part.lv === '1')
                .map((item, idx) => (
                  <MenuItem key={idx} value={item.sectorCd}>
                    {item.deptNm}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>
        </Stack>
      </CmmContainer>
      <CmmContainer sx={{ width: '100%', display: 'block' }}>
        <Typography component="h1" variant="h3" sx={{ textAlign: 'center' }}>
          Agent
        </Typography>
      </CmmContainer>
      <Box sx={{ flexGrow: 1 }}>
        <Stack>
          <Grid item xs={7} sm={7} md={7}>
            <CmmContainer>{monthChartParams?.series && <CustomCombinePairsChart title={`${srchData.year}년`} categories={monthChartParams?.categories} series={monthChartParams?.series} yaxis={monthChartParams?.yaxis} />}</CmmContainer>
          </Grid>
          <Grid item xs={5} sm={5} md={5} sx={{ mt: 2 }}>
            <CmmContainer>
              <CmmSubTitle title="월별 접속 현황" />
              <DataGrid rowHeight={40} rows={monthRows.filter((row) => Number(row.id.split('-')[1]) <= Number(month))} columns={columns} hideFooter onRowClick={handleRowClick} />
              <SalesTable>
                <SalesTableBody>
                  <SalesTableRow>
                    {columns.map((column) => (
                      <SalesTableCell th sx={{ textAlign: 'right', width: column.field === 'id' ? 100 : 150 }}>
                        {column.field === 'id' && '합계'}
                        {column.field === 'login' && `${monthRows[monthRows.length - 1]?.loginTotal.toLocaleString()}명`}
                        {column.field === 'logout' && `${monthRows[monthRows.length - 1]?.logoutTotal.toLocaleString()}건`}
                        {column.field === 'open' && `${monthRows[monthRows.length - 1]?.openTotal.toLocaleString()}건`}
                        {column.field === 'upload' && `${monthRows[monthRows.length - 1]?.uploadTotal.toLocaleString()}건`}
                      </SalesTableCell>
                    ))}
                  </SalesTableRow>
                </SalesTableBody>
              </SalesTable>
            </CmmContainer>
          </Grid>
        </Stack>
      </Box>

      <Dialog open={open} onClose={onClose} aria-labelledby="draggable-dialog-title" maxWidth="800">
        <DialogTitle id="draggable-dialog-title">{currentYearMonth} 접속 현황 상세보기</DialogTitle>
        <DialogContent dividers>
          <AgentDailyDetails currentYearMonth={currentYearMonth} partList={partList} part1={selectedPart !== 'all' ? partList.find((part) => part.sectorCd === selectedPart).deptCd : selectedPart} />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="success" onClick={onClose}>
            닫기
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
}

const logColumns = [
  { field: 'rowNumber', headerName: 'No', minWidth: 30, align: 'center' },
  {
    field: 'createdAt',
    headerName: '접속일자',
    minWidth: 180,
    align: 'center',
    valueGetter: (params) => moment(params.value).format('YYYY-MM-DD HH:mm:ss')
  },
  { field: 'pgm', headerName: '제품', minWidth: 180, align: 'center' },
  { field: 'ver', headerName: '버전', minWidth: 100, align: 'center' },
  { field: 'cpname', headerName: '회사', minWidth: 180, align: 'center' },
  { field: 'partname', headerName: '부서', minWidth: 180, align: 'center' },
  { field: 'username', headerName: '사용자', minWidth: 100, align: 'center' },
  { field: 'keycode', headerName: '사번', minWidth: 100, align: 'center' }
];
const logItems = [
  { value: 'DIDASAgent_Login', label: '접속자' },
  { value: 'DIDASAgent_Logout', label: '로그아웃' },
  { value: 'DIDASAgent_Open', label: '열람' },
  { value: 'DIDASAgent_Upload', label: '업로드' }
];
const logItemsExcel = [
  { value: 'DIDASAgent_Login', label: '접속자' },
  { value: 'DIDASAgent_Open', label: '열람' },
  { value: 'DIDASAgent_Upload', label: '업로드' }
];

const AgentDailyDetails = (props) => {
  const { currentYearMonth, partList, part1 } = props;

  const [monthChartParams, setMonthChartParams] = useState({});
  const [logs, setLogs] = useState([]);
  const [selectedKind, setSelectedKind] = useState('all');
  const [selectedPart1, setSelectedPart1] = useState('all');
  const [selectedPart2, setSelectedPart2] = useState('all');
  const [selectedPart3, setSelectedPart3] = useState('all');
  const [selectedPart4, setSelectedPart4] = useState('all');
  const [selectedPart5, setSelectedPart5] = useState('all');
  const [selectedPart, setSelectedPart] = useState({});
  const [selectedExcelKind, setSelectedExcelKind] = useState('DIDASAgent_Login');
  const [open, setOpen] = useState(false);
  const [startDt, setStartDt] = useState(moment());
  const [endDt, setEndDt] = useState(moment());
  const [isDuplicate, setIsDuplicate] = useState(true);

  const createDailyChart = (params) => {
    const today = moment().startOf('day'); // 오늘 날짜의 시작으로 설정 (시간 제거)
    const results = params.filter((t) => moment(t.id, 'YYYY-MM-DD') <= today);
    const categories = results.map((t) => t?.id);
    const series = [
      {
        name: '접속자',
        type: 'line',
        data: results.map((t, idx) => t?.login),
        yaxis: 0
      },
      {
        name: 'DIDAS 열람',
        type: 'line',
        data: results.map((t, idx) => t?.open),
        yaxis: 0
      },
      {
        name: '파일 업로드',
        type: 'line',
        data: results.map((t, idx) => t?.upload),
        yaxis: 0
      }
      // {
      //   name: '접속현황 누계',
      //   type: 'line',
      //   data: results.map((t, idx) => t?.agentTotal),
      //   yaxis: 1
      // }
    ];
    const yaxis = [
      {
        showAlways: true,
        title: {
          text: '접속자수/열람/업로드'
        }
      }
      // {
      //   show: false,
      //   opposite: true,
      //   title: {
      //     text: series[3].name
      //   }
      // }
    ];
    return { categories, series, yaxis };
  };

  const getChart = async () => {
    const splitYmd = props?.currentYearMonth?.split('-');
    let searchParams = { cond: 'day' };
    if (!!splitYmd.length) {
      searchParams.year = splitYmd[0];
      searchParams.month = splitYmd[1];
    }
    //차트 전체 추가
    await axios
      .get('/api/dashboard/anls-agent/chart', { params: searchParams })
      .then((response) => {
        const params = response.data;
        const result = createDailyChart(params);
        setMonthChartParams({ ...result });
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getLogs = async () => {
    const splitYmd = props?.currentYearMonth?.split('-');
    if (!!splitYmd.length) {
      await axios
        .get('/api/dashboard/anls-agent/logs', { params: { year: splitYmd[0], month: splitYmd[1] } })
        .then((response) => {
          const params = response.data;
          setLogs(params);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const download = () => {
    cmmUtils.excelDownload(
      excelLogRows,
      `${props?.currentYearMonth} Agent 사용 로그`,
      [
        { id: 'createdAt', label: '접속일자' },
        { id: 'pgm', label: '구분' },
        { id: 'ver', label: '버전' },
        { id: 'partname', label: '부서' },
        { id: 'username', label: '사용자' },
        { id: 'keycode', label: '사번' }
      ],
      false
    );
  };

  const handleChangeCheckbox = (e) => {
    setIsDuplicate(e.target.checked);
  };

  useEffect(async () => {
    if (open) {
      setSelectedExcelKind('DIDASAgent_Login');
      setStartDt(moment(props?.currentYearMonth).startOf('month'));
      setEndDt(moment(props?.currentYearMonth).endOf('month').isSameOrAfter(moment()) ? moment() : moment(props?.currentYearMonth).endOf('month'));
      setIsDuplicate(true);
    }
  }, [open]);

  useEffect(async () => {
    getChart();
    getLogs();
  }, []);

  useEffect(async () => {
    setSelectedPart2('all');
    setSelectedPart3('all');
    setSelectedPart4('all');
    setSelectedPart5('all');
  }, [selectedPart1]);

  useEffect(async () => {
    setSelectedPart3('all');
    setSelectedPart4('all');
    setSelectedPart5('all');
  }, [selectedPart2]);

  useEffect(async () => {
    setSelectedPart4('all');
    setSelectedPart5('all');
  }, [selectedPart3]);

  useEffect(async () => {
    setSelectedPart5('all');
  }, [selectedPart4]);

  const filterLogRows = logs
    .filter((t) => selectedKind === 'all' || t.pgm === selectedKind)
    .filter(
      (t) =>
        selectedPart1 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart1).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart2 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart2).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart3 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart3).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart4 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart4).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter((t) => selectedPart5 === 'all' || t.partname.includes(partList.find((t) => t.deptCd === selectedPart5).deptNm));

  const excelLogRows = logs
    .filter((t) => t.pgm === selectedExcelKind && moment(t.createdAt).format('YYYYMMDD') >= startDt.format('YYYYMMDD') && moment(t.createdAt).format('YYYYMMDD') <= endDt.format('YYYYMMDD'))
    .filter(
      (t) =>
        selectedPart1 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart1).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart2 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart2).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart3 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart3).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter(
      (t) =>
        selectedPart4 === 'all' ||
        partList
          .filter((part) => part.depthFullname.includes(partList.find((t) => t.deptCd === selectedPart4).deptNm))
          .map((part) => {
            return part.deptNm;
          })
          .includes(t.partname)
    )
    .filter((t) => selectedPart5 === 'all' || t.partname.includes(partList.find((t) => t.deptCd === selectedPart5).deptNm));

  return (
    <Box sx={{ mt: 3 }}>
      <Grid item xs={7} sm={7} md={7}>
        <CmmContainer>{monthChartParams?.series && <CustomCombinePairsChart title={props?.currentYearMonth} categories={monthChartParams?.categories} series={monthChartParams?.series} yaxis={monthChartParams?.yaxis} />}</CmmContainer>
      </Grid>
      <Grid item xs={5} sm={5} md={5} sx={{ mt: 2 }}>
        <CmmContainer>
          <CmmSubTitle title="일일 로그 상세" />
          <Stack direction="row" spacing={2}>
            <FormControl>
              <InputLabel variant="standard">구분</InputLabel>
              <Select labelId="gbn-label" name="month" value={selectedKind} label="검색기준" onChange={(e) => setSelectedKind(e.target.value)}>
                <MenuItem value={'all'}>전체</MenuItem>
                {logItems.map((item, idx) => (
                  <MenuItem key={idx} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl>
              <InputLabel variant="standard">부서</InputLabel>
              <Select labelId="gbn-label" name="part1" value={selectedPart1} label="검색기준" onChange={(e) => setSelectedPart1(e.target.value)}>
                <MenuItem value={'all'}>전체</MenuItem>
                {partList
                  .filter((part) => part.lv === '1')
                  .map((item, idx) => (
                    <MenuItem key={idx} value={item.deptCd}>
                      {item.deptNm}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            {selectedPart1 !== 'all' && (
              <FormControl>
                <Select labelId="gbn-label" name="part2" value={selectedPart2} label="검색기준" onChange={(e) => setSelectedPart2(e.target.value)}>
                  <MenuItem value={'all'}>전체</MenuItem>
                  {partList
                    .filter((part) => part.lv === '2' && part.parentDeptCd === selectedPart1)
                    .map((item, idx) => (
                      <MenuItem key={idx} value={item.deptCd}>
                        {item.deptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
            {selectedPart2 !== 'all' && (
              <FormControl>
                <Select labelId="gbn-label" name="part3" value={selectedPart3} label="검색기준" onChange={(e) => setSelectedPart3(e.target.value)}>
                  <MenuItem value={'all'}>전체</MenuItem>
                  {partList
                    .filter((part) => part.lv === '3' && part.parentDeptCd === selectedPart2)
                    .map((item, idx) => (
                      <MenuItem key={idx} value={item.deptCd}>
                        {item.deptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
            {selectedPart3 !== 'all' && (
              <FormControl>
                <Select labelId="gbn-label" name="part4" value={selectedPart4} label="검색기준" onChange={(e) => setSelectedPart4(e.target.value)}>
                  <MenuItem value={'all'}>전체</MenuItem>
                  {partList
                    .filter((part) => part.lv === '4' && part.parentDeptCd === selectedPart3)
                    .map((item, idx) => (
                      <MenuItem key={idx} value={item.deptCd}>
                        {item.deptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
            {selectedPart4 !== 'all' && (
              <FormControl>
                <Select labelId="gbn-label" name="part5" value={selectedPart5} label="검색기준" onChange={(e) => setSelectedPart5(e.target.value)}>
                  <MenuItem value={'all'}>전체</MenuItem>
                  {partList
                    .filter((part) => part.lv === '5' && part.parentDeptCd === selectedPart4)
                    .map((item, idx) => (
                      <MenuItem key={idx} value={item.deptCd}>
                        {item.deptNm}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            )}
            <Box display="flex" justifyContent="flex-end">
              <Button variant="outlined" color="success" onClick={handleClickOpen}>
                EXCEL DOWN
              </Button>
            </Box>
          </Stack>
          <DataGrid rowHeight={40} rows={filterLogRows} columns={logColumns} />
        </CmmContainer>
      </Grid>
      <Dialog open={open} onClose={handleClose} aria-labelledby="draggable-dialog-title" PaperProps={{ sx: { minWidht: 800, maxWidth: 1200 } }}>
        <DialogTitle id="draggable-dialog-title">Agent 접속 현황 Excel</DialogTitle>
        <Box id="restoreForm" component="form">
          <DialogContent dividers>
            <Box noValidate sx={{ display: 'block' }}>
              <Stack direction="row" spacing={2}>
                <FormControl autoWidth>
                  <InputLabel variant="standard">구분</InputLabel>
                  <Select labelId="gbn-label" name="month" value={selectedExcelKind} label="검색기준" onChange={(e) => setSelectedExcelKind(e.target.value)}>
                    {logItemsExcel.map((item, idx) => (
                      <MenuItem key={idx} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <DatePicker
                  format={'yyyy-MM-DD'}
                  label="시작일"
                  value={startDt}
                  minDate={moment(props?.currentYearMonth).startOf('month')}
                  maxDate={endDt}
                  onChange={(newValue) => {
                    setStartDt(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} helperText={null} />}
                  disableMaskedInput={true}
                />
                <DatePicker
                  format={'yyyy-MM-DD'}
                  label="종료일"
                  value={endDt}
                  minDate={startDt}
                  maxDate={moment(props?.currentYearMonth).endOf('month').isSameOrAfter(moment()) ? moment() : moment(props?.currentYearMonth).endOf('month')}
                  onChange={(newValue) => {
                    setEndDt(newValue);
                  }}
                  renderInput={(params) => <TextField {...params} helperText={null} />}
                  disableMaskedInput={true}
                />
                <FormControlLabel control={<Checkbox />} id="isDuplicate" name="isDuplicate" label="중복 제거" onChange={handleChangeCheckbox} checked={isDuplicate} />
              </Stack>
              <Stack direction="row" spacing={2} mt>
                <FormControl>
                  <InputLabel variant="standard">부서</InputLabel>
                  <Select labelId="gbn-label" name="excelPart" value={selectedPart1} label="검색기준" onChange={(e) => setSelectedPart1(e.target.value)}>
                    <MenuItem value={'all'}>전체</MenuItem>
                    {partList
                      .filter((part) => part.lv === '1')
                      .map((item, idx) => (
                        <MenuItem key={idx} value={item.deptCd}>
                          {item.deptNm}
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
                {selectedPart1 !== 'all' && (
                  <FormControl>
                    <Select labelId="gbn-label" name="part2" value={selectedPart2} label="검색기준" onChange={(e) => setSelectedPart2(e.target.value)}>
                      <MenuItem value={'all'}>전체</MenuItem>
                      {partList
                        .filter((part) => part.lv === '2' && part.depthFullname.includes(selectedPart1))
                        .map((item, idx) => (
                          <MenuItem key={idx} value={item.deptCd}>
                            {item.deptNm}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
                {selectedPart2 !== 'all' && (
                  <FormControl>
                    <Select labelId="gbn-label" name="part3" value={selectedPart3} label="검색기준" onChange={(e) => setSelectedPart3(e.target.value)}>
                      <MenuItem value={'all'}>전체</MenuItem>
                      {partList
                        .filter((part) => part.lv === '3' && part.depthFullname.includes(selectedPart1) && part.depthFullname.includes(selectedPart2))
                        .map((item, idx) => (
                          <MenuItem key={idx} value={item.deptCd}>
                            {item.deptNm}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
                {selectedPart3 !== 'all' && (
                  <FormControl>
                    <Select labelId="gbn-label" name="part2" value={selectedPart4} label="검색기준" onChange={(e) => setSelectedPart4(e.target.value)}>
                      <MenuItem value={'all'}>전체</MenuItem>
                      {partList
                        .filter((part) => part.lv === '4' && part.depthFullname.includes(selectedPart1) && part.depthFullname.includes(selectedPart2) && part.depthFullname.includes(selectedPart3))
                        .map((item, idx) => (
                          <MenuItem key={idx} value={item.deptCd}>
                            {item.deptNm}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
                {selectedPart4 !== 'all' && (
                  <FormControl>
                    <Select labelId="gbn-label" name="part5" value={selectedPart5} label="검색기준" onChange={(e) => setSelectedPart5(e.target.value)}>
                      <MenuItem value={'all'}>전체</MenuItem>
                      {partList
                        .filter(
                          (part) => part.lv === '5' && part.depthFullname.includes(selectedPart1) && part.depthFullname.includes(selectedPart2) && part.depthFullname.includes(selectedPart3) && part.depthFullname.includes(selectedPart4)
                        )
                        .map((item, idx) => (
                          <MenuItem key={idx} value={item.deptCd}>
                            {item.deptNm}
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                )}
              </Stack>
              <DataGrid
                rowHeight={40}
                rows={excelLogRows}
                columns={logColumns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 10
                    }
                  }
                }}
                pageSizeOptions={[10]}
                sx={{ mt: 1 }}
              />
            </Box>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" color="primary" onClick={download}>
              Download
            </Button>
            <Button variant="outlined" color="success" onClick={handleClose}>
              닫기
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </Box>
  );
};

const CustomCombinePairsChart = (props) => {
  const { categories, series, yaxis, title } = props;
  console.log('🔥csl🔥AnalysisAgent/CustomCombinePairsChart :979 - props = ', props);

  return (
    <CombinePairsChart
      title={title}
      categories={categories}
      series={series}
      yaxis={yaxis}
      tooltip={{
        y: [
          {
            formatter: function (val) {
              return val + ' (%)';
            }
          },

          {
            formatter: function (val) {
              return val + ' (%)';
            }
          },
          {
            formatter: function (val) {
              return val + ' (%)';
            }
          }
          // {
          //   formatter: function (val) {
          //     return val;
          //   }
          // }
        ]
      }}
    />
  );
};
